module.exports = __webpack_public_path__ + "img/adds.aee04159.png";